
















































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import CreateUser from './create-user.vue'
import EditUser from './edit-user.vue'
import {GetUserAll,EditUserIsLock} from '@/api/user';
import {
    CreateOrgDepartment,
    GetOrgDepartmentList,
} from "@/api/organization"
import {GetOraganizationList} from "@/api/organization"

import selectTree from '@/components/selectTree'
@Component({
    components:{CreateUser,EditUser,selectTree}
})
export default class Users extends AbpBase{
    props = {                // 配置项（必选）
        value: 'id',
        label: 'name',
        children: 'children',
    }
    getValue(value){
        this.organizationId = value
        this.table.page = 1;
        this.getData()
    }

    editUser:any = {}
    edit(user:any){
        this.editUser = user
        this.editModalShow=true;
    }

    createModalShow:boolean=false;
    editModalShow:boolean=false;
    
    
    create(){
        this.createModalShow=true;
    }
    deptlist = []
    departmentId = null
    oraganizationlist = []
    organizationId = null
    async getSelect(){
        this.deptlist = (await GetOrgDepartmentList({QueryString:'',Status:true,PageSize:10000,Page:1})).items
        let res = await GetOraganizationList({id:-1})
        this.getTree(
            res,
            this.oraganizationlist,
            {
                id:'id',
                name:'organizationName',
            },
            'parentId',
            'id',
        )
    }
    pageChange(page:number){
        this.table.page = page
        this.getData();
    }
    pagesizeChange(pagesize:number){
        this.table.pageSize = pagesize
        this.getData();
    }
    async lock(row:any){
        let res = await EditUserIsLock({userId:row.id,isLock:!row.isLock})
        if(res.code==2000){
            this.getData()
        }
    }
    list:any = []
    async getData(){
        this.table.loading = true
        let data = {
            Keyword:this.table.queryString,
            IsActive:this.table.status,
            OrganizationId:this.organizationId,
            DepartmentId:this.departmentId,
            PageSize:this.table.pageSize,
            Page:this.table.page,
        }
        let res = await GetUserAll(data)
        this.list = res.data.items
        this.table.totalCount = res.data.totalCount
        this.table.loading = false
    }
    columns=[{
        title:this.L('UserName'),
        key:'userName',
    },{
        title:this.L('Name'),
        key:'name',
        width:100,
    },{
        title:this.L('IsActive'),
        render:(h:any,params:any)=>{
           return h('span',params.row.isActive?this.L('Yes'):this.L('No'))
        }
    },{
        title:this.L('CreationTime'),
        key:'creationTime',
        render:(h:any,params:any)=>{
            return h('span',new Date(params.row.creationTime).toLocaleDateString())
        }
    },{
        title:'所属组织',
        key:'organizationName',
        width:260,
    },{
        title:'所属部门',
        key:'departmentName',
        width:260,
    },{
        title:this.L('LastLoginTime'),
        render:(h:any,params:any)=>{
            return h('span',new Date(params.row.lastLoginTime).toLocaleString())
        }
    },{
        title:this.L('Actions'),
        key:'Actions',
        width:180,
        render:(h:any,params:any)=>{
            return h('div',[
                h('el-button',{
                    props:{
                        type:'text',
                        size:'small',
                        icon:params.row.isLock?'el-icon-lock':'el-icon-unlock'
                    },
                    style:{
                        color:params.row.isLock?'#909399':'#67c23a',
                        marginRight:'5px'
                    },
                    on:{
                        click:()=>{
                            this.lock(params.row);
                        }
                    }
                },!params.row.isLock?'解除':'锁定'),
                h('el-button',{
                    props:{
                        type:'text',
                        size:'small'
                    },
                    style:{
                        marginRight:'5px'
                    },
                    on:{
                        click:()=>{
                            this.edit(params.row);
                        }
                    }
                },this.L('Edit')),
                h('el-button',{
                    props:{
                        type:'error',
                        size:'small'
                    },
                    on:{
                        click:async ()=>{
                            this.$confirm('此操作将永久删除该记录, 是否继续?', '提示',{
                                confirmButtonText:this.L('Yes'),
                                cancelButtonText:this.L('No')})
                                .then(async () => {
                                    await this.$store.dispatch({
                                        type:'user/delete',
                                        data:params.row
                                    })
                                    await this.getData();
                                })
                                .catch(() => {

                                });
                        }
                    }
                },this.L('Delete'))
            ])
        }
    }]
    async created(){
        this.getSelect()
        this.getData();
        await this.$store.dispatch({
            type:'user/getRoles'
        })
    }
}
